export default __webpack_public_path__ + "static/guy-a963fc9f537ee598efd6dff899805e64.jpg";